import axios from "../axios";
import { notifyDanger, notifySuccess } from "./customFn";

export const setLogin = () => {
  return {
    type: "SET_LOGIN",
    payload: true,
  };
};

export const setLogout = () => {
  return {
    type: "SET_LOGOUT",
    payload: false,
  };
};

export const asyncLogOut = (navigate) => {
  return (dispatch) => {
    const url = "/auth/logout";
    const data = {
      token: localStorage.getItem("MetBrains_token"),
      id: localStorage.getItem("MetBrains_id"),
      sessionId: localStorage.getItem("MetBrains_tracker_session_id"),
    };
    axios
      .post(url, data)
      .then((res) => {
        localStorage.removeItem("session_expired");
        localStorage.removeItem("usedOTP");
        localStorage.removeItem("MetBrains_token");
        localStorage.removeItem("MetBrains_role");
        localStorage.removeItem("MetBrains_id");
        localStorage.removeItem("x_session-token");
        localStorage.removeItem("MetBrains_tracker_session_id");
        if (navigate) {
          navigate("/");
        }
        dispatch(setLogout());
        notifySuccess("Logout successfully!");
      })
      .catch((err) => {
        // setIsLoading(false);
        console.log(err);
        // notifyDanger(err.response.data.message);
      });
  };
};

export const asyncOTPLogin = (
  formData,
  navigate,
  initialState,
  setIsLoading,
  setToken,
  setIsLoggedInDevice
) => {
  return (dispatch) => {
    const url = "/auth/login-otp";

    axios
      .post(url, formData)
      .then((res) => {
        const { message, data, token, sessionId, usedOTP } = res.data;
        dispatch(setLogin());
        localStorage.setItem("MetBrains_token", token);
        localStorage.setItem("MetBrains_role", data.typeOfUser);
        localStorage.setItem("MetBrains_id", data._id);
        localStorage.setItem("MetBrains_tracker_session_id", sessionId);
        localStorage.setItem("usedOTP", usedOTP);
        notifySuccess(message);
        initialState();
        setIsLoading(false);
        if (setToken) {
          setToken(token);
        }
        if (data.typeOfUser === "Student") {
          navigate("/dashboard");
        } else {
          navigate("/blog-dashboard/home");
        }
      })
      .catch((err) => {
        setIsLoading(false);
        const status = err?.response?.data?.status || "";
        if (status === 419 && setIsLoggedInDevice) {
          setIsLoggedInDevice(true);
        }
        console.log(err);
        notifyDanger(err.response.data.message);
      });
  };
};

export const asyncLogin = (
  formData,
  navigate,
  initialState,
  setIsLoading,
  setToken,
  setIsLoggedInDevice,
  setOTPTimer
) => {
  return (dispatch) => {
    const url = "/auth/login";

    axios
      .post(url, formData)
      .then((res) => {
        const { message, data, token, sessionId } = res.data;
        if (data.typeOfUser === "Student" || data.typeOfUser === "Blogger") {
          dispatch(setLogin());
          localStorage.setItem("MetBrains_token", token);
          localStorage.setItem("MetBrains_role", data.typeOfUser);
          localStorage.setItem("MetBrains_id", data._id);
          localStorage.setItem("MetBrains_tracker_session_id", sessionId);
          localStorage.removeItem("session_expired");
          localStorage.removeItem("usedOTP");
          notifySuccess(message);
          initialState();
          setIsLoading(false);
          dispatch({
            type: "SESSION_HAS_EXPIRED",
            payload: false,
          });
          if (setToken) {
            setToken(token);
          }
          if (data.typeOfUser === "Student") {
            navigate("/dashboard");
          } else {
            navigate("/blog-dashboard/home");
          }
        } else {
          notifyDanger("only student or blogger can login from this site! ");
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        const status = err?.response?.data?.status || "";
        if (status === 419 && setIsLoggedInDevice) {
          setIsLoggedInDevice(true);
          setOTPTimer(new Date(Date.now() + 5 * 60 * 1000));
        }
        console.log(err);
        notifyDanger(err.response.data.message);
      });
  };
};

export const updateTypeOfUser = (data, setIsLoading, navigate) => {
  return (dispatch) => {
    const url = "/auth/add-typeofuser";
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("MetBrains_token")}`,
      },
    };

    axios
      .put(url, data, config)
      .then((res) => {
        localStorage.setItem("MetBrains_role", data.typeOfUser);
        if (data.typeOfUser === "Student") {
          navigate("/dashboard");
        }
        if (data.typeOfUser === "Blogger") {
          navigate("/blog-dashboard/home");
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        notifyDanger(err.response.data.message);
      });
  };
};
